import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Link, Redirect} from 'react-router-dom';
import Overlay from '../Miscelania/Overlay';
import Select from 'react-select';
import RequestApi from '../Miscelania/RequestApi';

class EmailTrainingAvaliation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      training_id: '',
      clareza_dos_objetivos: 0,
      programa_proposto: 0,
      sistema_de_iscricao: 0,
      homogeniedade_do_grupo: 0,
      cumprimento_do_horario: 0,
      cumprimento_do_programa: 0,
      carga_horaria_realizada: 0,
      atingimento_dos_objetivos: 0,
      aplicabilidade_do_conteudo: 0,
      qualidade_do_conteudo: 0,
      quantidade_do_conteudo_teorico: 0,
      quantidade_do_conteudo_pratico: 0,
      quantidade_do_material_instrucional: 0,
      qualidade_do_material_instrucional: 0,
      atendimento_das_expectativas: 0,
      dominio_do_assunto: 0,
      clareza_e_objetividade: 0,
      estimulo_a_participacao_do_grupo: 0,
      adequacao_das_tecnicas_didaticas: 0,
      comunicacao_e_linguagem: 0,
      comentarios: null,
      training_avaliation_staffs: [],
    };
    this.add = this.add.bind(this);
    this.handleAlert = this.handleAlert.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleRadioChange (name, event) {
    var change = {};
    change[event] = name;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  componentDidMount() {
    this.loadData();
  }

  loadData() {
    var self = this;
    var datasave = {
      token: this.props.match.params.token,
    };

    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    fetch(config.get('api') + '/email/avaliacao', { method: 'POST', mode: 'cors', headers: headers, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      if (responseJson.status === "success") {
        self.setState({
          loaded: 1,
          training_certification_id: responseJson.data.training_certification_id,
          staff_id: responseJson.data.staff_id,
          training_certifications_list: responseJson.data.training_certifications_list,
          token: responseJson.data.token,
          training_certification_staffs_list: responseJson.data.training_certification_staffs_list,
          overlay: {message: '', type: '', status: 'closed'}, message: responseJson.message,
        });

      } else {
        self.handleAlert(
          responseJson.message,
          responseJson.status,
          "open"
        );
      }
    }).catch((error) => {
      console.error(error);
    });
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      token: this.props.match.params.token,
      clareza_dos_objetivos: this.state.clareza_dos_objetivos,
      programa_proposto: this.state.programa_proposto,
      sistema_de_iscricao: this.state.sistema_de_iscricao,
      homogeniedade_do_grupo: this.state.homogeniedade_do_grupo,
      cumprimento_do_horario: this.state.cumprimento_do_horario,
      cumprimento_do_programa: this.state.cumprimento_do_programa,
      carga_horaria_realizada: this.state.carga_horaria_realizada,
      atingimento_dos_objetivos: this.state.atingimento_dos_objetivos,
      aplicabilidade_do_conteudo: this.state.aplicabilidade_do_conteudo,
      qualidade_do_conteudo: this.state.qualidade_do_conteudo,
      quantidade_do_conteudo_teorico: this.state.quantidade_do_conteudo_teorico,
      quantidade_do_conteudo_pratico: this.state.quantidade_do_conteudo_pratico,
      quantidade_do_material_instrucional: this.state.quantidade_do_material_instrucional,
      qualidade_do_material_instrucional: this.state.qualidade_do_material_instrucional,
      atendimento_das_expectativas: this.state.atendimento_das_expectativas,
      dominio_do_assunto: this.state.dominio_do_assunto,
      clareza_e_objetividade: this.state.clareza_e_objetividade,
      estimulo_a_participacao_do_grupo: this.state.estimulo_a_participacao_do_grupo,
      adequacao_das_tecnicas_didaticas: this.state.adequacao_das_tecnicas_didaticas,
      comunicacao_e_linguagem: this.state.comunicacao_e_linguagem,
      comentarios: this.state.comentarios,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/avaliacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({
          loaded: 0,
        });  
        self.handleAlert(
          responseJson.message,
          responseJson.status,
          "open"
        );
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title">Avaliação do treinamento</h3>
      {this.state.loaded === 1 &&
        <form onSubmit={this.add}> 
          <div className="row">
            <div className="col-md-6 form-group">
              <div className="form-group">
                <label>Colaborador:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={'Selecionar colaborador'}
                  onChange={this.handleSelectChange.bind(this, 'staff_id')}
                  options={this.state.training_certification_staffs_list}
                  disabled
                  required
                />
              </div>
            </div>
            <div className="col-md-6 form-group">
              <div className="form-group">
                <label>Aula:</label>
                <Select
                  className="form-field-name"
                  name="certification_id"
                  value={this.state.training_certification_id}
                  searchable={true}
                  placeholder={'Selecionar fornecedor'}
                  onChange={this.handleSelectChange.bind(this, 'training_certification_id')}
                  options={this.state.training_certifications_list}
                  disabled
                  required
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Clareza dos objetivos:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'clareza_dos_objetivos')} type="radio" name="clareza_dos_objetivos" value="1" checked={ (self.state.clareza_dos_objetivos == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'clareza_dos_objetivos')} type="radio" name="clareza_dos_objetivos" value="2" checked={ (self.state.clareza_dos_objetivos == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'clareza_dos_objetivos')} type="radio" name="clareza_dos_objetivos" value="3" checked={ (self.state.clareza_dos_objetivos == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'clareza_dos_objetivos')} type="radio" name="clareza_dos_objetivos" value="4" checked={ (self.state.clareza_dos_objetivos == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <div className="col-md-6 form-group">
              <label>Programa proposto:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'programa_proposto')} type="radio" name="programa_proposto" value="1" checked={ (self.state.programa_proposto == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'programa_proposto')} type="radio" name="programa_proposto" value="2" checked={ (self.state.programa_proposto == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'programa_proposto')} type="radio" name="programa_proposto" value="3" checked={ (self.state.programa_proposto == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'programa_proposto')} type="radio" name="programa_proposto" value="4" checked={ (self.state.programa_proposto == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Sistema de Inscrição</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'sistema_de_iscricao')} type="radio" name="sistema_de_iscricao" value="1" checked={ (self.state.sistema_de_iscricao == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'sistema_de_iscricao')} type="radio" name="sistema_de_iscricao" value="2" checked={ (self.state.sistema_de_iscricao == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'sistema_de_iscricao')} type="radio" name="sistema_de_iscricao" value="3" checked={ (self.state.sistema_de_iscricao == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'sistema_de_iscricao')} type="radio" name="sistema_de_iscricao" value="4" checked={ (self.state.sistema_de_iscricao == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <div className="col-md-6 form-group">
              <label>Homogeniedade do Grupo</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'homogeniedade_do_grupo')} type="radio" name="homogeniedade_do_grupo" value="1" checked={ (self.state.homogeniedade_do_grupo == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'homogeniedade_do_grupo')} type="radio" name="homogeniedade_do_grupo" value="2" checked={ (self.state.homogeniedade_do_grupo == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'homogeniedade_do_grupo')} type="radio" name="homogeniedade_do_grupo" value="3" checked={ (self.state.homogeniedade_do_grupo == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'homogeniedade_do_grupo')} type="radio" name="homogeniedade_do_grupo" value="4" checked={ (self.state.homogeniedade_do_grupo == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Cumprimento do Horário:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'cumprimento_do_horario')} type="radio" name="cumprimento_do_horario" value="1" checked={ (self.state.cumprimento_do_horario == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'cumprimento_do_horario')} type="radio" name="cumprimento_do_horario" value="2" checked={ (self.state.cumprimento_do_horario == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'cumprimento_do_horario')} type="radio" name="cumprimento_do_horario" value="3" checked={ (self.state.cumprimento_do_horario == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'cumprimento_do_horario')} type="radio" name="cumprimento_do_horario" value="4" checked={ (self.state.cumprimento_do_horario == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <div className="col-md-6 form-group">
              <label>Cumprimento do Programa:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'cumprimento_do_programa')} type="radio" name="cumprimento_do_programa" value="1" checked={ (self.state.cumprimento_do_programa == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'cumprimento_do_programa')} type="radio" name="cumprimento_do_programa" value="2" checked={ (self.state.cumprimento_do_programa == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'cumprimento_do_programa')} type="radio" name="cumprimento_do_programa" value="3" checked={ (self.state.cumprimento_do_programa == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'cumprimento_do_programa')} type="radio" name="cumprimento_do_programa" value="4" checked={ (self.state.cumprimento_do_programa == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Carga Horária Realizada:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'carga_horaria_realizada')} type="radio" name="carga_horaria_realizada" value="1" checked={ (self.state.carga_horaria_realizada == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'carga_horaria_realizada')} type="radio" name="carga_horaria_realizada" value="2" checked={ (self.state.carga_horaria_realizada == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'carga_horaria_realizada')} type="radio" name="carga_horaria_realizada" value="3" checked={ (self.state.carga_horaria_realizada == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'carga_horaria_realizada')} type="radio" name="carga_horaria_realizada" value="4" checked={ (self.state.carga_horaria_realizada == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <div className="col-md-6 form-group">
              <label>Atingimento dos Objetivos:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'atingimento_dos_objetivos')} type="radio" name="atingimento_dos_objetivos" value="1" checked={ (self.state.atingimento_dos_objetivos == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'atingimento_dos_objetivos')} type="radio" name="atingimento_dos_objetivos" value="2" checked={ (self.state.atingimento_dos_objetivos == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'atingimento_dos_objetivos')} type="radio" name="atingimento_dos_objetivos" value="3" checked={ (self.state.atingimento_dos_objetivos == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'atingimento_dos_objetivos')} type="radio" name="atingimento_dos_objetivos" value="4" checked={ (self.state.atingimento_dos_objetivos == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Aplicabilidade do Conteúdo:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'aplicabilidade_do_conteudo')} type="radio" name="aplicabilidade_do_conteudo" value="1" checked={ (self.state.aplicabilidade_do_conteudo == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'aplicabilidade_do_conteudo')} type="radio" name="aplicabilidade_do_conteudo" value="2" checked={ (self.state.aplicabilidade_do_conteudo == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'aplicabilidade_do_conteudo')} type="radio" name="aplicabilidade_do_conteudo" value="3" checked={ (self.state.aplicabilidade_do_conteudo == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'aplicabilidade_do_conteudo')} type="radio" name="aplicabilidade_do_conteudo" value="4" checked={ (self.state.aplicabilidade_do_conteudo == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <div className="col-md-6 form-group">
              <label>Qualidade do Conteúdo:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'qualidade_do_conteudo')} type="radio" name="qualidade_do_conteudo" value="1" checked={ (self.state.qualidade_do_conteudo == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'qualidade_do_conteudo')} type="radio" name="qualidade_do_conteudo" value="2" checked={ (self.state.qualidade_do_conteudo == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'qualidade_do_conteudo')} type="radio" name="qualidade_do_conteudo" value="3" checked={ (self.state.qualidade_do_conteudo == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'qualidade_do_conteudo')} type="radio" name="qualidade_do_conteudo" value="4" checked={ (self.state.qualidade_do_conteudo == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Quantidade do Conteúdo Teórico:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'quantidade_do_conteudo_teorico')} type="radio" name="quantidade_do_conteudo_teorico" value="1" checked={ (self.state.quantidade_do_conteudo_teorico == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'quantidade_do_conteudo_teorico')} type="radio" name="quantidade_do_conteudo_teorico" value="2" checked={ (self.state.quantidade_do_conteudo_teorico == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'quantidade_do_conteudo_teorico')} type="radio" name="quantidade_do_conteudo_teorico" value="3" checked={ (self.state.quantidade_do_conteudo_teorico == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'quantidade_do_conteudo_teorico')} type="radio" name="quantidade_do_conteudo_teorico" value="4" checked={ (self.state.quantidade_do_conteudo_teorico == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <div className="col-md-6 form-group">
              <label>Quantidade do Conteúdo Prático:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'quantidade_do_conteudo_pratico')} type="radio" name="quantidade_do_conteudo_pratico" value="1" checked={ (self.state.quantidade_do_conteudo_pratico == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'quantidade_do_conteudo_pratico')} type="radio" name="quantidade_do_conteudo_pratico" value="2" checked={ (self.state.quantidade_do_conteudo_pratico == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'quantidade_do_conteudo_pratico')} type="radio" name="quantidade_do_conteudo_pratico" value="3" checked={ (self.state.quantidade_do_conteudo_pratico == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'quantidade_do_conteudo_pratico')} type="radio" name="quantidade_do_conteudo_pratico" value="4" checked={ (self.state.quantidade_do_conteudo_pratico == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Quantidade do Material Instrucional:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'quantidade_do_material_instrucional')} type="radio" name="quantidade_do_material_instrucional" value="1" checked={ (self.state.quantidade_do_material_instrucional == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'quantidade_do_material_instrucional')} type="radio" name="quantidade_do_material_instrucional" value="2" checked={ (self.state.quantidade_do_material_instrucional == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'quantidade_do_material_instrucional')} type="radio" name="quantidade_do_material_instrucional" value="3" checked={ (self.state.quantidade_do_material_instrucional == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'quantidade_do_material_instrucional')} type="radio" name="quantidade_do_material_instrucional" value="4" checked={ (self.state.quantidade_do_material_instrucional == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <div className="col-md-6 form-group">
              <label>Qualidade do Material Instrucional:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'qualidade_do_material_instrucional')} type="radio" name="qualidade_do_material_instrucional" value="1" checked={ (self.state.qualidade_do_material_instrucional == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'qualidade_do_material_instrucional')} type="radio" name="qualidade_do_material_instrucional" value="2" checked={ (self.state.qualidade_do_material_instrucional == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'qualidade_do_material_instrucional')} type="radio" name="qualidade_do_material_instrucional" value="3" checked={ (self.state.qualidade_do_material_instrucional == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'qualidade_do_material_instrucional')} type="radio" name="qualidade_do_material_instrucional" value="4" checked={ (self.state.qualidade_do_material_instrucional == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Atendimento das Expectativas:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'atendimento_das_expectativas')} type="radio" name="atendimento_das_expectativas" value="1" checked={ (self.state.atendimento_das_expectativas == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'atendimento_das_expectativas')} type="radio" name="atendimento_das_expectativas" value="2" checked={ (self.state.atendimento_das_expectativas == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'atendimento_das_expectativas')} type="radio" name="atendimento_das_expectativas" value="3" checked={ (self.state.atendimento_das_expectativas == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'atendimento_das_expectativas')} type="radio" name="atendimento_das_expectativas" value="4" checked={ (self.state.atendimento_das_expectativas == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <hr/>
          <h3 className="page-title">Avaliação do(s) Instrutor(es)</h3>
          <hr/>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Domínio do Assunto:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'dominio_do_assunto')} type="radio" name="dominio_do_assunto" value="1" checked={ (self.state.dominio_do_assunto == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'dominio_do_assunto')} type="radio" name="dominio_do_assunto" value="2" checked={ (self.state.dominio_do_assunto == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'dominio_do_assunto')} type="radio" name="dominio_do_assunto" value="3" checked={ (self.state.dominio_do_assunto == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'dominio_do_assunto')} type="radio" name="dominio_do_assunto" value="4" checked={ (self.state.dominio_do_assunto == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <div className="col-md-6 form-group">
              <label>Clareza e Objetividade:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'clareza_e_objetividade')} type="radio" name="clareza_e_objetividade" value="1" checked={ (self.state.clareza_e_objetividade == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'clareza_e_objetividade')} type="radio" name="clareza_e_objetividade" value="2" checked={ (self.state.clareza_e_objetividade == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'clareza_e_objetividade')} type="radio" name="clareza_e_objetividade" value="3" checked={ (self.state.clareza_e_objetividade == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'clareza_e_objetividade')} type="radio" name="clareza_e_objetividade" value="4" checked={ (self.state.clareza_e_objetividade == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Estímulo a Participação do Grupo:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'estimulo_a_participacao_do_grupo')} type="radio" name="estimulo_a_participacao_do_grupo" value="1" checked={ (self.state.estimulo_a_participacao_do_grupo == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'estimulo_a_participacao_do_grupo')} type="radio" name="estimulo_a_participacao_do_grupo" value="2" checked={ (self.state.estimulo_a_participacao_do_grupo == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'estimulo_a_participacao_do_grupo')} type="radio" name="estimulo_a_participacao_do_grupo" value="3" checked={ (self.state.estimulo_a_participacao_do_grupo == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'estimulo_a_participacao_do_grupo')} type="radio" name="estimulo_a_participacao_do_grupo" value="4" checked={ (self.state.estimulo_a_participacao_do_grupo == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <div className="col-md-6 form-group">
              <label>Adequação das Técnicas Didáticas:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'adequacao_das_tecnicas_didaticas')} type="radio" name="adequacao_das_tecnicas_didaticas" value="1" checked={ (self.state.adequacao_das_tecnicas_didaticas == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'adequacao_das_tecnicas_didaticas')} type="radio" name="adequacao_das_tecnicas_didaticas" value="2" checked={ (self.state.adequacao_das_tecnicas_didaticas == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'adequacao_das_tecnicas_didaticas')} type="radio" name="adequacao_das_tecnicas_didaticas" value="3" checked={ (self.state.adequacao_das_tecnicas_didaticas == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'adequacao_das_tecnicas_didaticas')} type="radio" name="adequacao_das_tecnicas_didaticas" value="4" checked={ (self.state.adequacao_das_tecnicas_didaticas == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Comunicação e Linguagem:</label>
              <div className="form-group">
                <input onChange={self.handleRadioChange.bind(self, 1, 'comunicacao_e_linguagem')} type="radio" name="comunicacao_e_linguagem" value="1" checked={ (self.state.comunicacao_e_linguagem == 1) ? 'checked' : '' }/> RUIM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 2, 'comunicacao_e_linguagem')} type="radio" name="comunicacao_e_linguagem" value="2" checked={ (self.state.comunicacao_e_linguagem == 2) ? 'checked' : '' }/> REGULAR &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 3, 'comunicacao_e_linguagem')} type="radio" name="comunicacao_e_linguagem" value="3" checked={ (self.state.comunicacao_e_linguagem == 3) ? 'checked' : '' }/>  BOM &nbsp;&nbsp;&nbsp;
                <input onChange={self.handleRadioChange.bind(self, 4, 'comunicacao_e_linguagem')} type="radio" name="comunicacao_e_linguagem" value="4" checked={ (self.state.comunicacao_e_linguagem == 4) ? 'checked' : '' }/>  ÓTIMO &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <div className="form-group">
            <label>Comentários e Sugestões:</label>
              <textarea style={{ height: 100 }} type="text" name="comentarios" className="form-control" value={this.state.comentarios} onChange={this.handleChange.bind(this, 'comentarios')} />
          </div>
          <hr/>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-plus"></i> Adicionar avaliação</button>
        </form>
      }
    </div>
  </div>  
</div>
    );
  }
}

export default EmailTrainingAvaliation;


// WEBPACK FOOTER //
// ./src/Components/Users/EmailTrainingAvaliation.js